export default function Dryer(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.52734 4.75542V11.5758C2.52734 11.918 2.80436 12.1951 3.14606 12.1951H4.85021L8.71555 13.6017H19.6039H27.6158C28.6409 13.6017 29.4725 12.7707 29.4725 11.7451V4.38304C29.4725 3.35796 28.6409 2.52637 27.6158 2.52637H8.83682L4.80061 4.14213L3.14821 4.13674C2.80544 4.13566 2.52734 4.41319 2.52734 4.75542Z"
                stroke="#757575"
                strokeWidth="1.2"
            />
            <path
                d="M25.5905 13.6021V26.505C25.5905 28.145 24.2614 29.4741 22.6214 29.4741C20.9819 29.4741 19.6523 28.145 19.6523 26.505V13.6021"
                stroke="#757575"
                strokeWidth="1.2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.1012 23.9867H20.6851C20.123 23.9867 19.667 23.5313 19.667 22.9692V19.6708C19.667 19.1087 20.123 18.6533 20.6851 18.6533H21.1012C21.6627 18.6533 22.1187 19.1087 22.1187 19.6708V22.9692C22.1187 23.5313 21.6627 23.9867 21.1012 23.9867Z"
                stroke="#757575"
                strokeWidth="1.2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.1012 21.2306H20.6851C20.123 21.2306 19.667 20.7752 19.667 20.2131V19.6703C19.667 19.1087 20.123 18.6528 20.6851 18.6528H21.1012C21.6627 18.6528 22.1187 19.1087 22.1187 19.6703V20.2131C22.1187 20.7752 21.6627 21.2306 21.1012 21.2306Z"
                stroke="#757575"
                strokeWidth="1.2"
            />
            <path d="M8.7168 13.6017V2.52637" stroke="#757575" strokeWidth="1.2" />
        </svg>
    );
}
